import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ProxyInfo, WebsocketConnection } from "../common.browser/Exports";
import { PropertyId } from "../sdk/Exports";
import { ConnectionFactoryBase } from "./ConnectionFactoryBase";
import { WebsocketMessageFormatter } from "./Exports";
import { HeaderNames } from "./HeaderNames";
import { QueryParameterNames } from "./QueryParameterNames";
export var SpeechSynthesisConnectionFactory = function SpeechSynthesisConnectionFactory() {
  var _this = this;

  _classCallCheck(this, SpeechSynthesisConnectionFactory);

  this.synthesisUri = "/cognitiveservices/websocket/v1";

  this.create = function (config, authInfo, connectionId) {
    var endpoint = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Endpoint, undefined);
    var region = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Region, undefined);
    var hostSuffix = ConnectionFactoryBase.getHostSuffix(region);
    var endpointId = config.parameters.getProperty(PropertyId.SpeechServiceConnection_EndpointId, undefined);
    var hostPrefix = endpointId === undefined ? "tts" : "voice";
    var host = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Host, "wss://" + region + "." + hostPrefix + ".speech" + hostSuffix);
    var queryParams = {};

    if (!endpoint) {
      endpoint = host + _this.synthesisUri;
    }

    var headers = {};

    if (authInfo.token !== undefined && authInfo.token !== "") {
      headers[authInfo.headerName] = authInfo.token;
    }

    headers[HeaderNames.ConnectionId] = connectionId;

    if (endpointId !== undefined) {
      headers[QueryParameterNames.CustomVoiceDeploymentId] = endpointId;
    }

    config.parameters.setProperty(PropertyId.SpeechServiceConnection_Url, endpoint);
    var enableCompression = config.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
    return new WebsocketConnection(endpoint, queryParams, headers, new WebsocketMessageFormatter(), ProxyInfo.fromParameters(config.parameters), enableCompression, connectionId);
  };
};